module.exports = __webpack_public_path__ + "img/bank-industry-problem-icon.bedee692.png";